<div class="mb-5" *ngIf="inputType == 'image' || inputType == 'floor'">
  <div class="upload-header">
    <h3 class="upload-title">
      <b class="upload-img">Uploaded Images</b>
      <span>(Drag to reorder photos)</span>
    </h3>
    <div
      *ngIf="featureType === 'myHome'"
      class="dropzone"
      (drop)="onDrop($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
    >
      <label for="file-upload" class="upload_btn">
        <img src="../../../../assets/images/add.png" width="15" />
        Upload Photos
      </label>
      <input id="file-upload" type="file" multiple (change)="selectFiles($event)" />
    </div>
  </div>

  <mat-error>{{ message }}</mat-error>

  <div class="photos w_100" *ngIf="featureType === 'myListing'">
    <ul class="photo_restrictions">
      <li>
        Optional: If you already have your photos, you may upload your photos here. You may add, update, or remove your
        photos at any time in the listing process.
      </li>
      <li>
        Photos must be original photo files and can not be Google Maps, Google Earth images, screenshots of photos,
        thumbnail versions of photos, or owned by someone else. Images from previous listing may be owned by the agent
        who paid for them.
      </li>
      <li>Once all the photos are uploaded, you can rearrange them to display in your desired order on the listing.</li>
    </ul>

    <div class="example-form mt-10 my-4">
      <div class="fields">
        <mat-checkbox color="secondary" [checked]="photographyRelease" (change)="changePhotographyRelease($event)">
          Photography Release (I own these photos or have explicit permission to use them for publishing to the MLS)
        </mat-checkbox>
      </div>
    </div>

    <div
      class="dropzone center"
      (drop)="onDrop($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
    >
      <div class="drop">
        <div class="upload-div">
          <div class="img-div">
            <div class="gallery_icon"></div>
          </div>
          <div>
            <p class="drag_text">Drag your photos here</p>
            <p class="format_text">You can upload JPEG, JPG, PNG, HEIC file format</p>
          </div>
        </div>

        <div class="text_divider">OR</div>

        <div>
          <label for="listing-file-upload" class="upload_btn"> UPLOAD FROM YOUR DEVICE </label>

          <input
            id="listing-file-upload"
            class="file-input-hidden"
            type="file"
            multiple
            accept="image/jpeg,image/jpg,image/png,image/heic"
            (change)="selectFiles($event)"
          />
        </div>
      </div>
    </div>

    <!-- My Listing Image Preview -->
    <div
      class="mt-4"
      *ngIf="alreadyUploadedImages && alreadyUploadedImages.length > 0"
      cdkDropList
      [cdkDropListData]="alreadyUploadedImages"
      (cdkDropListDropped)="drop($event)"
    >
      <div class="selected_images">
        <div *ngFor="let previewsItem of alreadyUploadedImages; let i = index" cdkDrag>
          <div class="image_wrap">
            <button
              class="delete_icon"
              *ngIf="!previewsItem.loading"
              [matMenuTriggerFor]="listingMenu"
              #menuTrigger="matMenuTrigger"
              type="button"
            >
              <i class="fa fa-ellipsis-v"></i>
            </button>

            <mat-menu #listingMenu="matMenu">
              <button mat-menu-item *ngIf="!previewsItem.loading" (click)="setDefaultImageModal(previewsItem.url)">
                <mat-icon class="pr-3">perm_media</mat-icon>
                <span class="default-lbl">Set as default</span>
              </button>

              <button mat-menu-item *ngIf="!previewsItem.loading" (click)="deleteImages(i)">
                <mat-icon class="pr-3">delete</mat-icon>
                Delete
              </button>
            </mat-menu>

            <button class="drag_icon" type="button">
              {{ i + 1 }}
            </button>

            <div
              class="image_container"
              [ngClass]="{
                highlight: uploadedFilesResult?.defaultPropertyImage === previewsItem.url,
                default: uploadedFilesResult?.defaultPropertyImage !== previewsItem.url
              }"
              style="position: relative"
            >
              <img class="preview_image" [src]="previewsItem.url" alt="" (click)="openGallery(i, 'image')" />

              <div *ngIf="previewsItem.loading" class="spinner"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="featureType === 'myHome'"
    class=""
    [ngStyle]="{ 'margin-top': alreadyUploadedImages.length == 0 ? '0' : '36px' }"
    cdkDropList
    [cdkDropListData]="alreadyUploadedImages"
    (cdkDropListDropped)="drop($event)"
  >
    <div class="selected_images" *ngIf="inputType == 'image'">
      <div class="" *ngFor="let previewsItem of alreadyUploadedImages; let i = index" cdkDrag>
        <div class="image_wrap">
          <div></div>
          <button
            class="delete_icon"
            *ngIf="!previewsItem.loading"
            [matMenuTriggerFor]="menu"
            #menuTrigger="matMenuTrigger"
          >
            <i class="fa fa-ellipsis-v"></i>
          </button>

          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="!previewsItem.loading" (click)="setDefaultImageModal(previewsItem.url)">
              <mat-icon class="pr-3">perm_media</mat-icon>Set as default image
            </button>
            <button mat-menu-item *ngIf="!previewsItem.loading" (click)="deleteImages(i)">
              <mat-icon class="pr-3">delete</mat-icon>Delete
            </button>
          </mat-menu>
          <button class="drag_icon">
            {{ i + 1 }}
          </button>
          <div
            class="image_container"
            [ngClass]="{
              highlight: uploadedFilesResult.defaultPropertyImage === previewsItem.url,
              default: uploadedFilesResult.defaultPropertyImage !== previewsItem.url
            }"
            style="position: relative"
          >
            <img class="preview_image" [src]="previewsItem.url" alt="" (click)="openGallery(i, 'image')" />

            <div *ngIf="previewsItem.loading" class="spinner"></div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #setDefaultImageDialog>
      <div>
        <h3 mat-dialog-title>Are you sure you want to set this image as the profile image for the property?</h3>
        <div mat-dialog-content>
          <div class="row">
            <div class="col-md-12">
              <div class="w-100 text-right mt-3">
                <button type="button" mat-stroked-button color="primary" (click)="closeModal()">No</button>
                <button type="submit" (click)="setDefaultImage()" mat-flat-button class="ml-2" color="primary">
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="selected_images" *ngIf="inputType == 'floor'">
      <div class="image_wrap" *ngFor="let previewsItem of alreadyUploadedFloorImages; let i = index" cdkDrag>
        <button class="delete_icon" *ngIf="!previewsItem.loading" (click)="deleteImages(i)">
          <img src="../../../assets/images/delete_icon.svg" alt="" />
        </button>
        <button class="drag_icon">
          {{ i + 1 }}
        </button>
        <div class="image_container" style="position: relative">
          <img class="preview_image" [src]="previewsItem.url" alt="" (click)="openGallery(i, 'floor')" />
          <div *ngIf="previewsItem.loading" class="spinner"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Document Uploads  -->
  <div *ngIf="inputType == 'document'">
    <div class="dropzone center">
      <label for="file-upload pr-3" class="upload_btn" (click)="openModal()">
        <!-- <img src="../../../../assets/images/add.png" width="15px" /> -->
        Upload Document
      </label>
    </div>
    <div class="clearfix"></div>
    <ng-template #documentUploadDialog>
      <div class="confirmDialogWrap">
        <button class="close" mat-button mat-dialog-close type="button" [disabled]="" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>

        <div>
          <h3 mat-dialog-title>Upload Document</h3>

          <div mat-dialog-content>
            <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field class="w-100">
                    <input matInput id="name" formControlName="name" type="text" placeholder="Document Name" />
                    <div *ngIf="myForm.get('name').invalid && myForm.get('name').touched">
                      <small *ngIf="myForm.get('name').errors?.required">Name is required.</small>
                    </div>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <mat-label><b>Upload Document:</b></mat-label>
                  <br />
                  <input class="mt-2" type="file" (change)="onFileSelected($event)" />
                  <div *ngIf="fileErrorMessage">
                    <mat-error>{{ fileErrorMessage }}</mat-error>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="w-100 text-right mt-3">
                    <button type="button" mat-stroked-button color="primary" (click)="closeModal()">Close</button>
                    <button
                      type="submit"
                      mat-flat-button
                      class="ml-2"
                      color="primary"
                      [disabled]="myForm.invalid || !selectedFile"
                      [pmx-progress-button]="inProgressDocumentUpload"
                    >
                      Upload
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </ng-template>
    <div class="image_wrap mt-3">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Document Name</th>
            <th scope="col">Date</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let previewsItem of uploadedArrayResult?.document; let i = index">
            <td>{{ previewsItem.name }}</td>
            <td>{{ previewsItem.createdDate | simpleDate }}</td>
            <td class="icon">
              <i class="fa fa-trash" (click)="deleteImages(i)"></i>
              <i class="fa fa-download" (click)="downloadFile(previewsItem.Location, 'testing')" aria-hidden="true"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #setDefaultListingImageDialog>
  <div>
    <h3 mat-dialog-title>Are you sure you want to set this image as the profile image for the property?</h3>
    <div mat-dialog-content>
      <div class="row">
        <div class="col-md-12">
          <div class="w-100 text-right mt-3">
            <button type="button" mat-stroked-button color="primary" (click)="closeModal()">No</button>
            <button type="submit" (click)="setDefaultImage()" mat-flat-button class="ml-2" color="primary">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
